import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinActivityEquipment = createAsyncThunk(
  "activityequipment/getMin",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMinMasterActivityEquipment",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getMinActivityEquipmentSearch = createAsyncThunk(
  "activityequipment/getMinSearch",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMinMasterActivityEquipment",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        let newObj = [];
        response.data.data.map((item) =>
          newObj.push({
            value: item.activityequipmentID,
            label: item.Namaactivityequipment,
          })
        );
        return { data: newObj };
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getActivityEquipment = createAsyncThunk(
  "activityequipment/get",
  async ({ start, count, search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMasterActivityEquipment",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertactivityequipment = createAsyncThunk(
  "activityequipment/insert",
  async ({ ActivityEquipment }, thunkAPI) => {
    let formData = new FormData();
    formData.append("ActivityEquipment", ActivityEquipment);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertMasteractivityequipment",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateactivityequipment = createAsyncThunk(
  "activityequipment/update",
  async ({ ActivityEquipment, ID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("ActivityEquipment", ActivityEquipment);
    formData.append("ID", ID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateMasteractivityequipment",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

const initialState = {
  message: "",
  minData: [],
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

export const activityequipmentSlice = createSlice({
  name: "activityequipment",
  initialState,
  reducers: {},
  extraReducers: {
    [getMinActivityEquipment.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minData = payload.data;
      return state;
    },
    [getMinActivityEquipment.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload.message;
    },
    [getMinActivityEquipment.pending]: (state) => {
      state.isMinFetching = true;
    },

    [getActivityEquipment.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getActivityEquipment.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload.message;
    },
    [getActivityEquipment.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertactivityequipment.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [insertactivityequipment.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload.message;
    },
    [insertactivityequipment.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updateactivityequipment.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [updateactivityequipment.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [updateactivityequipment.pending]: (state) => {
      state.isUpdateFetching = true;
    },
    // UPDATE
    [getMinActivityEquipmentSearch.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.minData = payload.data;

      return state;
    },
    [getMinActivityEquipmentSearch.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [getMinActivityEquipmentSearch.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const activityequipmentSelector = (state) => state.activityequipment;
